if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.submitButton = this.querySelector('[type="submit"]');
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.submitButton.querySelector('span').style.visibility = 'hidden';
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const productDetails = JSON.parse(this.querySelector('[data-product-json]').textContent);

      if (!this.dataset.nostoAtc) {
        const config = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: `application/json`,
          }
        }
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        const giftWrapping = document.querySelector('gift-wrapping');

        if (giftWrapping && giftWrapping.querySelector('.disclosure__link--active').dataset.value != '') {
          const giftWrappingId = giftWrapping.querySelector('.disclosure__link--active').dataset.value;
          const giftWrappingName = giftWrapping.querySelector('.disclosure__link--active').dataset.name;
          const variantId = this.form.querySelector('[name="items[0]id"]').value;

          const parentKey =  window.btoa([giftWrappingId, variantId].join(','));
          formData.append('items[0]properties[_itemKey]', parentKey);
          formData.append(`items[0]properties[${window.variantStrings.gift_wrapping.wrapping_property_label || 'Gift wrapping'}]`, giftWrappingName);
          formData.append('items[1]id', giftWrappingId);
          formData.append('items[1]properties[_parentKey]', parentKey);
          formData.append('items[1]properties[_giftWrapping]', 'true');
          formData.append(`items[1]properties[${window.variantStrings.gift_wrapping.product_property_label || 'Product'}]`, productDetails.product.title);
        }

        config.body = formData;

        try {
          const res = await fetch(routes.cart_add_url + '.js', config)
          const json = await res.json();

          if (res.status !== 200) throw new Error(json.description);

          const productQuantity = formData.get('quantity');

          document.dispatchEvent(new CustomEvent('ajaxProduct:added',{
            detail: {
              json: json
            }
          }));

          document.dispatchEvent(new CustomEvent('datalayer:productAdded', {
            detail: {
              product: productDetails,
              quantity: productQuantity ? parseInt(productQuantity) : 1,
              price: json.price
            }
          }));
        } catch(error) {
          this.handleErrorMessage(error);
          console.error(error);
        }
      } else {
        const productId = this.dataset.productId;
        const variantId = this.form.querySelector('[name=id]').value;

        try {
          await Nosto.addSkuToCart({productId: productId, skuId: variantId}, this);

          document.dispatchEvent(new CustomEvent('ajaxProduct:added'));

          document.dispatchEvent(new CustomEvent('datalayer:productAdded', {
            detail: {
              product: productDetails,
              quantity: 1,
              price: json.price
            }
          }));

        } catch(error) {
          this.handleErrorMessage(error);
          console.error(error);
        }
      }

      this.submitButton.classList.remove('loading');
      this.submitButton.removeAttribute('aria-disabled');
      this.submitButton.querySelector('span').style.visibility = 'visible';
      this.querySelector('.loading-overlay__spinner').classList.add('hidden');
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {

        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
